'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowInstaller = exports.KendoWindowInstaller = exports.Window = exports.KendoWindow = undefined;

var _KendoWindow = require('./KendoWindow');

var _KendoWindow2 = _interopRequireDefault(_KendoWindow);

var _kendoWindowInstaller = require('./kendo-window-installer');

var _kendoWindowInstaller2 = _interopRequireDefault(_kendoWindowInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoWindow = _KendoWindow2.default;
exports.Window = _KendoWindow2.default;
exports.KendoWindowInstaller = _kendoWindowInstaller2.default;
exports.WindowInstaller = _kendoWindowInstaller2.default;